let menuIsOpen = false;
const menu = document.getElementById('js-menu');
const menuButtons = document.getElementsByClassName('js-menu-toggle-button');
function openMenu() {
    menuIsOpen = true;
    [menu, ...menuButtons].forEach((button) => {
        if (button instanceof HTMLElement) {
            button.dataset.menuState = 'open';
        }
    });
}
function closeMenu() {
    menuIsOpen = false;
    [menu, ...menuButtons].forEach((button) => {
        if (button instanceof HTMLElement) {
            button.dataset.menuState = 'closed';
        }
    });
}
function toggleMenu() {
    if (menuIsOpen) {
        closeMenu();
    }
    else {
        openMenu();
    }
}
export default function initMenu() {
    [...menuButtons].forEach((button) => {
        button.addEventListener('click', toggleMenu);
    });
}
